import Icon from "./Icon";
import React from "react";

function Select({name, label, icon, value, placeholder, options, onChange, simple}) {
    name = name ? name : simple ? "selectSimple" : "select";
    label = label ? label.toString().trim() : "";

    return (
        <div className="form-control-select-simple">

            {label !== "" ?
                <label htmlFor={name}>
                    {
                        icon ? <Icon i={icon}/> : null
                    }
                    <span>{label}:</span>
                </label>
                : null}


            <select name={name}
                    id={name}
                    value={value}
                    onChange={e => {
                        if (onChange) {
                            onChange(name, e.target.value);
                        }
                    }}>
                {placeholder ?
                    <option value="">{placeholder}</option>
                    : null}
                {
                    options?.map((o, i) =>
                        <option value={o.v} key={name + "-option-" + i}>{o.t}</option>
                    )
                }
            </select>
        </div>
    )


}

export default Select;